import {Singleton} from "../../base/singleton";

export class MenuTriggersController extends Singleton {
    private triggers: HTMLElement[] = Array.from(document.querySelectorAll('[data-menu-trigger]'));

    protected constructor() {
        super();
    }

    public onTriggerClick(callback: () => void) {
        this.triggers.forEach(trigger => {
            trigger.addEventListener('click', callback.bind(this));
        });
    }
}